module.exports = __webpack_public_path__ + "img/Hero_Photo.d02ea266.jpg";